(() => {
  const selectTab = (root, button) => {
    const panelId = button.getAttribute('aria-controls');
    root.querySelectorAll('[role="tab"]').forEach((tab) => {
      const selected = tab === button;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.classList.toggle('is-active', selected);
    });
    root.querySelectorAll('[data-ts-review-panel]').forEach((panel) => {
      panel.hidden = panel.id !== panelId;
    });
  };

  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-ts-review-tab]');
    if (tab) {
      const root = tab.closest('[data-ts-review-tabs]');
      if (root) selectTab(root, tab);
      return;
    }

    const helpful = event.target.closest('[data-ts-review-helpful]');
    if (!helpful || helpful.getAttribute('aria-pressed') === 'true') return;

    helpful.setAttribute('aria-pressed', 'true');
    const countNode = helpful.querySelector('[data-ts-review-helpful-count]');
    if (countNode) {
      const next = (Number.parseInt(countNode.textContent || '0', 10) || 0) + 1;
      countNode.textContent = String(next);
    }

    const reviewId = helpful.getAttribute('data-review-id');
    if (reviewId && window.fetch) {
      fetch('/apps/timeseek-reviews/api/helpful', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ review_id: reviewId }),
        keepalive: true,
      }).catch(() => {});
    }
  });

  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest?.('[data-ts-review-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const root = tab.closest('[data-ts-review-tabs]');
    if (!root) return;
    const tabs = Array.from(root.querySelectorAll('[data-ts-review-tab]'));
    const current = tabs.indexOf(tab);
    if (current < 0 || tabs.length < 2) return;

    event.preventDefault();
    const target = event.key === 'Home'
      ? tabs[0]
      : event.key === 'End'
        ? tabs[tabs.length - 1]
        : tabs[(current + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
    target.focus();
    selectTab(root, target);
  });

  const normalize = (value) => (value || '').toString().trim().toLowerCase();

  const applyHubFilters = (root) => {
    const cards = Array.from(root.querySelectorAll('[data-ts-review-card]'));
    const brand = normalize(root.querySelector('[data-ts-filter-brand]')?.value);
    const model = normalize(root.querySelector('[data-ts-filter-model]')?.value);
    const reference = normalize(root.querySelector('[data-ts-filter-reference]')?.value);
    const rating = Number.parseInt(root.querySelector('[data-ts-filter-rating]')?.value || '0', 10);
    const photoOnly = root.querySelector('[data-ts-filter-photo]')?.checked || false;
    const sort = root.querySelector('[data-ts-sort]')?.value || 'newest';
    const list = root.querySelector('[data-ts-review-list]');
    const empty = root.querySelector('[data-ts-review-empty]');

    const visible = cards.filter((card) => {
      const matchesBrand = !brand || normalize(card.dataset.brand).includes(brand);
      const matchesModel = !model || normalize(card.dataset.model).includes(model);
      const matchesReference = !reference || normalize(card.dataset.reference).includes(reference);
      const matchesRating = !rating || Number(card.dataset.rating || 0) >= rating;
      const matchesPhoto = !photoOnly || card.dataset.hasPhoto === 'true';
      return matchesBrand && matchesModel && matchesReference && matchesRating && matchesPhoto;
    });

    const sorted = [...cards].sort((a, b) => {
      if (sort === 'highest') return Number(b.dataset.rating || 0) - Number(a.dataset.rating || 0);
      if (sort === 'helpful') return Number(b.dataset.helpful || 0) - Number(a.dataset.helpful || 0);
      return Number(b.dataset.submittedAt || 0) - Number(a.dataset.submittedAt || 0);
    });

    sorted.forEach((card) => {
      const isVisible = visible.includes(card);
      card.hidden = !isVisible;
      if (list) list.appendChild(card);
    });

    if (empty) empty.hidden = visible.length > 0;
  };

  document.addEventListener('input', (event) => {
    const root = event.target.closest('[data-ts-reviews-hub]');
    if (root) applyHubFilters(root);
  });

  document.addEventListener('change', (event) => {
    const root = event.target.closest('[data-ts-reviews-hub]');
    if (root) applyHubFilters(root);
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-ts-reviews-hub]').forEach(applyHubFilters);
  });
})();
